/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type DevicesV2ControllerFindAllDeviceRelationTypeRole =
  (typeof DevicesV2ControllerFindAllDeviceRelationTypeRole)[keyof typeof DevicesV2ControllerFindAllDeviceRelationTypeRole];

export const DevicesV2ControllerFindAllDeviceRelationTypeRole = {
  DC: 'dc',
  DM: 'dm',
} as const;
